import React from "react"
import "./Fun.css"
import Button from "@material-ui/core/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlay} from "@fortawesome/free-solid-svg-icons";
import GagPost from "../GagPost/GagPost";
import {getPosts} from "../../api/api_post";

export default class Fun extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            apiPost: null,
            // darkTheme: false,
            darkTheme: true,
            currentPage: this.props.match.params.page,
            lastPageNumber: 1
        }

        this.getPrevPost = this.getPrevPost.bind(this)
        this.getNextPost = this.getNextPost.bind(this)
        this.getPost = this.getPost.bind(this)
        this.handleKeyPress = this.handleKeyPress.bind(this)
    }

    componentDidMount() {
        document.body.className = 'body-fun';
        this.getPost(this.props.match.params.page)
        document.addEventListener("keydown", this.handleKeyPress, false);
    }

    getPrevPost() {
        let page = parseInt(this.state.currentPage) + 1
        this.props.history.push(page.toString())
        this.getPost(page)
    }

    getNextPost() {
        let page = parseInt(this.state.currentPage) - 1
        this.props.history.push(page.toString())
        this.getPost(page)
    }

    getPost(page) {
        Promise.all([getPosts({page: page})]).then((promisesResults) => {
            const [posts] = promisesResults

            let lastPageNumber = posts['hydra:view']['hydra:last'].split('=')
            lastPageNumber = lastPageNumber[lastPageNumber.length - 1]

            this.setState({
                apiPost: posts['hydra:member'][0],
                currentPage: page,
                lastPageNumber: lastPageNumber
            })
        })
    }

    handleKeyPress(event)  {
        if(event.key === 'ArrowRight' && this.state.currentPage > 1){
            this.getNextPost()
        } else if (event.key === 'ArrowLeft' && this.state.currentPage < this.state.lastPageNumber) {
            this.getPrevPost()
        }
    }

    render() {

        let previousButton = ""
        if (this.state.currentPage < this.state.lastPageNumber) {
            previousButton =
                <Button variant="contained"
                        className={(this.state.darkTheme ? "prev-post-darkTheme" : "prev-post-lightTheme") + " prev-post"}
                        onClick={this.getPrevPost}>
                    <FontAwesomeIcon
                        className="btn-go-fun-fa-fixed"
                        icon={faPlay}
                        size="2x"
                        flip="both"
                    />
                </Button>
        }


        let nextButton = ""
        if (this.state.currentPage > 1) {
            nextButton =
                <Button variant="contained"
                        className={(this.state.darkTheme ? "next-post-darkTheme" : "next-post-lightTheme") + " next-post"}
                        onClick={this.getNextPost}>
                    <FontAwesomeIcon
                        className="btn-go-fun-fa"
                        icon={faPlay}
                        size="2x"
                    />
                </Button>
        }

        let gagPost = ""
        if (this.state.apiPost !== null) {
            gagPost = <GagPost
                key={this.state.apiPost.id}
                gag={this.state.apiPost}
                darkTheme={this.state.darkTheme}
            />
        }

        return <div>
            {previousButton}
            {nextButton}
            {gagPost}
        </div>
    }
}